<div class="tw:flex tw:items-center tw:gap-2.5">
  <div class="tw:flex tw:flex-col tw:gap-2 tw:flex-1">
    <input type="range"
           class="scale-slider tw:w-full"
           [min]="min"
           [max]="max"
           [step]="step"
           [value]="value"
           [disabled]="disabled"
           [style.background]="trackBackground"
           (input)="onInput($event)" />
    @if (labels.length) {
      <div class="tw:flex tw:justify-between tw:text-[9px] tw:text-[#bbb] tw:px-0.5">
        @for (label of labels; track $index) {
          <span>{{ label }}</span>
        }
      </div>
    }
  </div>
  @if (display === 'percent') {
    <div class="tw:flex tw:items-center tw:gap-1 tw:text-xs tw:font-semibold tw:whitespace-nowrap tw:min-w-[70px]"
         [style.color]="valueColour">
      <input type="number"
             class="scale-number tw:text-right"
             [min]="min"
             [max]="max"
             [step]="step"
             [value]="value"
             [disabled]="disabled"
             (input)="onNumberInput($event)"
             (blur)="onNumberBlur($event)" />
      <span>%</span>
    </div>
  } @else {
    <div class="tw:text-xs tw:font-semibold tw:text-right tw:whitespace-nowrap tw:min-w-[50px]"
         [style.color]="valueColour">
      {{ valueText }}
    </div>
  }
</div>
